import React, { useState, useEffect } from 'react';
import { getUIState, isPremiumUser, refreshHomePageDetails } from '../utils/auth_utils';
import { errorMsg, homeUrl, isBlankOrNullString, success } from '../utils/common_utils';
import { addCompanyUrlsInPlace } from './all_questions_utils';
import { NavbarTop } from '../common_components/navbar_top';
import { LockIcon, UnlockIcon } from '../common_components/common_icons';
import { useParams } from 'react-router-dom';
import { TagsListUI } from '../questions/tags_list_ui';
import IndefiniteProgressBar from '../common_components/indefinite_progress_bar';
import { ConnectAndBook } from '../common_components/connect_and_book';

function CompanyQuestionsTable() {
  const [questionList, setQuestionList] = useState([]);
  const [message, setMessage] = useState('');
  const[error, setError] = useState('')
  const [companyName, setCompanyName]=useState('')
  const[showProgressBar, setShowProgressBar] = useState(false)
  const isPremium=isPremiumUser();
  const uiState=getUIState()
  console.log("going to build all questions table : ")

  const { companyCode } = useParams();

  console.log("company code "+companyCode)  
  if(isBlankOrNullString(companyCode))  window.location.href="/"

useEffect(() => {
  setShowProgressBar(true)
    console.log("fetching the all questions list");
    fetch(homeUrl()+"questionsApi/companyQuestions/"+companyCode, {
      method: "GET"
    })
      .then((response) => response.json())
      .then((data) => {
        setShowProgressBar(false);
        if(success(data.status)){
          addCompanyUrlsInPlace(data.questions)
          setQuestionList(data.questions)
          if(data.questions && data.questions.length>0){
            for(const company of data.questions[0].companies)
                if(company.code==companyCode.trim())
                    setCompanyName(company.name)
          }
          else{
            setMessage("No questions found for "+companyCode)
            setShowProgressBar(false);
          }
        }
        else{
          setError(data.message || "Error in fetching questions, please try again")
        }
          console.log("response received "+data.questions.length+" questions")
          console.log(data);
          refreshHomePageDetails()
      })
      .catch((error) => {
        setShowProgressBar(false);
        console.log("error occured in fetching all questions "+JSON.stringify(error));
        setError(errorMsg())
      });  
}, []); // empty bracket means there are no dependencies which will make useEffect re run
// Talk is cheap, show me the code

// overflow-x-hidden I don't want page to scroll
  return (
    <div className = "flex flex-col overflow-x-hidden w-full items-center  justify-center ">
    <NavbarTop />
    <div className='mt-20'></div>
    <br />
    { companyCode &&
      <div className='text-4xl p-8 text-gray-700'>
        <span className='text-teal-600 font-bold'> {companyName} </span> Low 
        Level Design & DSA based Design Questions
        <br /> 
        </div>
        
    }  
    {
      false && questionList && questionList.length>=10 &&
      <div className='text-sm text-gray-500 italic text-center'>
        We continuously update/rearrange below list.  <br />
        It always reflects Most Frequently asked {companyName} questions in last 6 months
      </div>
    }
    <br /><br />
    {questionList.length>0 &&  
    <div className='flex flex-col 
    overflow-x-auto mx-2 md:mx-0 
     whitespace-nowrap w-full justify-center items-center'>
    {/*
    overflow-x-auto is needed to make it scroll separately from parent 
    forcing column to be in single line using whitespace-nowrap
    mx-auto in below table tag is for centering the table
     */}

    <table className="table-auto mx-auto border-collapse md:w-4/5  py-8 ">
      {/* used overflow-x-auto because I want scroll bars to be visible */}
      <thead className="">
        <tr className="text-gray-700 bg-white
         items-center justify-center text-center">
       { !isPremium && // shows lock/unlock icons when user is not premium
       <th className="px-2 py-3  text-left pl-6  text-gray-400 font-normal ">   </th>
      }
      <th className=" w-8 text-gray-400 font-normal  ">
            Id
          </th>

        <th className="px-2 py-3 text-left text-gray-400 font-normal  ">
            Title
          </th>
          
        <th className="px-2 py-3 text-left text-gray-400 font-normal  ">
            Companies
          </th>
          <th className="px-2 pl-6 ml-6 py-3 text-left text-gray-400 font-normal ">
            Design Pattern
          </th> 

        { false &&  <th className="px-2 py-3 ml-2 mr-4 text-gray-400 font-normal ">
            Difficulty
          </th> 
        }
        </tr>
      </thead>
      
      <tbody className=' font-normal'>
        {questionList.map((question) => (
          <tr key={question.questionId} className="border-b border-gray-200 hover:text-blue-700
          even:white odd:bg-gray-100">
           { // show lock/unlock icons column only if user is not premium else hide it.
           !isPremium && 
           <td className=" pl-6 py-3">
            { question.type==1 && !isPremium &&
            <LockIcon />
            } 
            {(question.type!=1 || isPremium) && 
            <UnlockIcon />
            }  
            </td>
          }

          <td>
           <span className="px-4 text-sm flex items-center justify-center
           text-center text-gray-500">
             {question.questionId}. </span>
          </td>

            <td className="px-4 pl-1 py-3">
              <a href={`/question/${question.questionId}`} 
              className="text-black hover:text-blue-600 ">{question.heading}</a>
            </td>

            <td className="px-4 pl-1 py-3">
              { question.companies &&
                <TagsListUI title={`${question.questionId}. ${question.heading}`}
                            tags={question.companies} />

              }
            </td>
           
            <td className="px-2 pl-6 ml-6 py-3 text-gray-500">
              {removeAfterComma(question.designPatterns)}
              </td> 

              { false && 
               <td>
              <div className={`text-lg md:mr-8 md:ml-4 ${
                question.difficulty === 1 ? 'text-orange-500' :
                question.difficulty === 2 ? 'text-red-600' :
                'text-green-500'
              }` }>
                {question.difficulty==1?'Medium':
                question.difficulty==2?'Hard':
                'Easy'}
              </div>
            
            </td>   
          }
          </tr>
        ))}
      </tbody>

    </table>
    </div>
  }
 
{!error && !message && questionList.length==0 &&
<div className="text-2xl font-bold text-blue-700">
  Loading all Questions. <br /> Please wait ...
</div>
}

{showProgressBar &&
<div className=" mt-32  z-50">
  <IndefiniteProgressBar />  </div> 
}

{error && error.length>0 &&
<div className="text-lg font-semibold text-red-700">
 {error} <br /> 
</div>
}

{message && message.length>0 && !error && error.length==0 &&
<div className="text-xl font-bold text-blue-700">
 {message} <br /> 
</div>
}
<br /> <br /> <br /><br />
<ConnectAndBook />
<div className='w-full  bg-gray-500 h-16 p-4
 text-center text-white items-center justify-center'>
    
</div>

</div>
);
        
}

function removeAfterComma(text){
 if(text==null||!text||text.length==0) return ''
 let index=text.indexOf(',')
 if(index<0) return text
 return text.substring(0, index)
}

export {CompanyQuestionsTable};

